import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-549c5a92"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cm-ui-table-wrapper online-black-and-white-list-wrap",
  style: {"align-items":"center","margin-top":"140px"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "cm-ui-pb15 cm-ui-pt15",
  style: {"font-weight":"bold","font-size":"14px"}
}

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'online-black-and-white-list',
  setup(__props) {

const { t, locale } = useI18n()
const router = useRouter()

const accessRestrictionImages: Record<string, string> = {
  'zh-CN': require('../_assets/zh-CN/access_restriction.png'),
  'zh-TW': require('../_assets/zh-TW/access_restriction.png'),
  'en-US': require('../_assets/en-US/access_restriction.png'),
  'ja-JP': require('../_assets/ja-JP/access_restriction.png'),
}

const bannerImage = computed(() => accessRestrictionImages[locale.value] || accessRestrictionImages['zh-CN'])

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: bannerImage.value,
      width: "240",
      height: "120",
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.migrateDomainTip')), 1),
    _createVNode(_component_el_button, {
      class: "cm-ui-mt10",
      style: {"width":"100px"},
      size: "small",
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/dashboard/access-restriction')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.migrateGoView')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})